import styled, { css } from 'styled-components'
import { colors } from '@diversioteam/diversio-ds'

import { ContainerProps, ContentAreaProps, ChildrenWrapperProps, BannerWrapperProps } from './AppLayout.types'

export const Container = styled.div<ContainerProps>`
    min-height: 100vh;
    background-color: ${colors.primaryWhite};
    padding-top: 64px;
    padding-bottom: 32px;

    @media (min-width: 768px) {
        padding-top: 84px;
        padding-bottom: 32px;
    }
`

export const MainWrapper = styled.div`
    display: flex;
    position: relative;
    min-height: calc(100vh - 64px);

    @media (min-width: 768px) {
        min-height: calc(100vh - 84px);
    }
`

export const ContentArea = styled.div<ContentAreaProps>`
    flex: 1;
    overflow: visible;
    transition: all ease-in-out;
    margin-left: ${(props) => props.$marginLeft};
    transition-duration: ${(props) => props.$transitionDuration}ms;
    ${(props) =>
        props.$isMobile &&
        css`
            width: 100%;
        `}
`

export const ChildrenWrapper = styled.div<ChildrenWrapperProps>`
    min-height: 100%;
    padding: ${(props) => (props.$isMobile ? '1rem' : '0')};
`

export const BannerWrapper = styled.div<BannerWrapperProps>`
    max-width: 72rem;
    margin: 0 auto;
    padding: ${(props) => (props.$isMobile ? '0 1rem' : '0 1.5rem')};
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const MobileOverlay = styled.div`
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 40;

    @media (min-width: 768px) {
        display: none;
    }
`
